import React from 'react';
import { useEffect, useState,useLayoutEffect } from "react";
import { BrowserRouter, Routes, Route, NavLink, useLocation } from 'react-router-dom';
import Footer from '../../components/Footer';
import { Heart, Activity, Droplets, TrendingUp, ExternalLink, Stethoscope, Calendar, Shield } from 'lucide-react';

const MainReserveContainer = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [
    '/images/banner1.png',
    '/images/banner2.png',
    '/images/banner3.png'
  ];

  useEffect(() => {
    const intervalId = setInterval(() => {
      // 現在のインデックスを更新して次の画像に移動
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // 2秒ごとにスライド

    // コンポーネントがアンマウントされたらタイマーをクリア
    return () => clearInterval(intervalId);
  }, [images.length]);

  // 診療科目のアイコンマッピング
  const getSubjectIcon = (subject) => {
    const iconMap = {
      diabetes: <Droplets className="medical_subject_icon" />,
      hypertension: <Heart className="medical_subject_icon" />,
      gout: <Activity className="medical_subject_icon" />,
      hyperlipidemia: <TrendingUp className="medical_subject_icon" />
    };
    return iconMap[subject] || <Stethoscope className="medical_subject_icon" />;
  };

  return (
    <div className="sunny_container">
        <h1 className="mypage_reservation_h1">診療科目</h1>

        <div className="medical_benefits_banner">
          <div className="medical_benefits_content">
            <Shield className="medical_benefits_icon" />
            <span className="medical_benefits_text">保険適用＆当日予約可能</span>
          </div>
        </div>

        <div className="medical_subjects_grid">
          <NavLink to="/reserve/diabetes/4" className="medical_subject_card diabetes_card">
            <div className="medical_subject_icon_wrapper diabetes_icon">
              <img src="/images/subject_icon_4.png" className="medical_subject_image"/>
              {getSubjectIcon('diabetes')}
            </div>
            <div className="medical_subject_content" style={{paddingLeft:'6px'}}>
              <h4 className="medical_subject_title">糖尿病</h4>
              <p className="medical_subject_description">血糖値管理・継続治療</p>
            </div>
            <div className="medical_subject_arrow">
              <Calendar className="subject_calendar_icon" />
            </div>
          </NavLink>

          <NavLink to="/reserve/hypertension/1" className="medical_subject_card hypertension_card">
            <div className="medical_subject_icon_wrapper hypertension_icon">
              <img src="/images/subject_icon_1.png" className="medical_subject_image" />
              {getSubjectIcon('hypertension')}
            </div>
            <div className="medical_subject_content" style={{paddingLeft:'6px'}}>
              <h4 className="medical_subject_title">高血圧</h4>
              <p className="medical_subject_description">血圧管理・生活指導</p>
            </div>
            <div className="medical_subject_arrow">
              <Calendar className="subject_calendar_icon" />
            </div>
          </NavLink>

          <NavLink to="/reserve/gout/2" className="medical_subject_card gout_card">
            <div className="medical_subject_icon_wrapper gout_icon">
              <img src="/images/subject_icon_2.png" className="medical_subject_image"/>
              {getSubjectIcon('gout')}
            </div>
            <div className="medical_subject_content" style={{paddingLeft:'6px'}}>
              <h4 className="medical_subject_title">痛風</h4>
              <p className="medical_subject_description">尿酸値管理・発作予防</p>
            </div>
            <div className="medical_subject_arrow">
              <Calendar className="subject_calendar_icon" />
            </div>
          </NavLink>

          <NavLink to="/reserve/hyperlipidemia/3" className="medical_subject_card hyperlipidemia_card">
            <div className="medical_subject_icon_wrapper hyperlipidemia_icon">
              <img src="/images/subject_icon_3.png" className="medical_subject_image"/>
              {getSubjectIcon('hyperlipidemia')}
            </div>
            <div className="medical_subject_content" style={{paddingLeft:'6px'}}>
              <h4 className="medical_subject_title">高脂血症</h4>
              <p className="medical_subject_description">コレステロール管理</p>
            </div>
            <div className="medical_subject_arrow">
              <Calendar className="subject_calendar_icon" />
            </div>
          </NavLink>

          <NavLink to="https://liff.line.me/1645278921-kWRPP32q/?accountId=mentalcare" className="medical_subject_card hyperlipidemia_card" style={{marginBottom:'32px'}}>
            <div className="medical_subject_icon_wrapper hyperlipidemia_icon">
              <img src="/images/banner4.jpg" className="medical_subject_image"/>
              {getSubjectIcon('hyperlipidemia')}
            </div>
            <div className="medical_subject_content" style={{paddingLeft:'6px'}}>
              <h4 className="medical_subject_title">精神科・心療内科</h4>
              <p className="medical_subject_description">うつ病・適応障害</p>
            </div>
            <div className="mental_care_arrow">
              <ExternalLink className="mental_care_external_icon" />
            </div>
          </NavLink>
        </div>

        <Footer />
    </div>
  );
};

export default MainReserveContainer;